import React, { useContext } from 'react'

import { CrissCross, Summary } from '../../../storybook'
import { getUrl } from '../../../utils/urls'
import { LocationContext } from '../../page-wrapper'

import { MediaComponent } from './mediaComponent'

import { useNavigationData } from '@/src/context/NavigationContext'

const BlockCrissCross = ({ data }) => {
  const {
    title,
    preface,
    description,
    action,
    secondaryAction,
    image,
    orientation,
    anchor,
    headingType,
    wistiaVideo
  } = data
  const location = useContext(LocationContext)
  const { navigationItems } = useNavigationData()
  const { slugPrefix } = location

  return (
    <CrissCross reverse={orientation === 'right'} anchor={anchor}>
      {image || wistiaVideo ? (
        <MediaComponent {...{ image, wistiaVideo }} height={620} width={620} />
      ) : null}

      <Summary
        headingType={headingType || 'h3'}
        title={title}
        subtitle={preface}
        description={description}
        action={
          action &&
          action.title && {
            label: action.title,
            url: getUrl({
              navItem: action,
              slugPrefix: slugPrefix,
              navigationItems: navigationItems
            })
          }
        }
        secondaryAction={
          secondaryAction &&
          secondaryAction.title && {
            label: secondaryAction.title,
            url: getUrl({
              navItem: secondaryAction,
              slugPrefix: slugPrefix,
              navigationItems: navigationItems
            })
          }
        }
        classes="c-criss-cross-summary"
      />
    </CrissCross>
  )
}

export default BlockCrissCross
